import { Route, Routes } from "react-router-dom";

import React from "react";
import ClassesOverview from "./ClassesOverview";
import ClassViewBase from "./ClassView";

export const ClassesRoutes = () => {
  return (
    <Routes>
      <Route path="/view/:id" element={<ClassViewBase />} />
      <Route path="/" element={<ClassesOverview />} />
    </Routes>
  );
};
